import { ArrowLeft } from "lucide-react";
import type { SrRoute, SrGroup } from "./types";
import { SR_NAV } from "./types";
import { Logo } from "../Logo";
import { navigateRoute } from "../../routeNav";

type BadgeCounts = Partial<Record<SrRoute, number>>;

interface Props {
  route: SrRoute;
  badges: BadgeCounts;
  onNavigate: (r: SrRoute) => void;
  /** Shows the admin-only items. False (the default) while the role loads. */
  isAdmin?: boolean;
}

const GROUP_LABELS: Record<SrGroup, string> = {
  "real-time": "Real-time",
  "ai-usage": "AI usage",
  evidence: "Evidence",
  config: "Configuration",
};

export function Sidebar({ route, badges, onNavigate, isAdmin = false }: Props) {
  const groups: SrGroup[] = ["real-time", "ai-usage", "evidence", "config"];
  return (
    <nav className="sr-sidebar" aria-label="Security Room navigation">
      <div className="sr-sidebar__title">
        <span className="sr-sidebar__mark" aria-hidden="true">
          <Logo />
        </span>
        <span>Security Room</span>
      </div>
      {groups.map((group) => (
        <div key={group} className="sr-sidebar__group">
          <div className="sr-sidebar__group-label">{GROUP_LABELS[group]}</div>
          {SR_NAV.filter((n) => n.group === group && (!n.adminOnly || isAdmin)).map((item) => {
            const count = badges[item.id] ?? 0;
            return (
              <button
                key={item.id}
                type="button"
                className={`sr-sidebar__item${route === item.id ? " is-active" : ""}`}
                onClick={() => onNavigate(item.id)}
              >
                <span>{item.label}</span>
                {count > 0 && <span className="sr-sidebar__badge">{count}</span>}
              </button>
            );
          })}
        </div>
      ))}
      {/* Escape hatch back to the workbench — client-side nav (keeps terminals
          alive; see routeNav). The Monitor view previously had no way back. */}
      <button type="button" className="sr-sidebar__back" onClick={() => navigateRoute("/")}>
        <ArrowLeft size={14} aria-hidden="true" />
        <span>Back to workbench</span>
      </button>
    </nav>
  );
}
